import { Component } from '@angular/core';

@Component({
    selector: 'ms-my-bets-auto-cashout-badge',
    template: ` <ms-help-box-badge [boxType]="'paidoutautocashout'" /> `,
})
export class MyBetsAutoCashoutBadgeComponent {}
